@if (isEnabled && !isMobile) {
  @if (store.widgetState() === 'opened') {
    <app-chat-window
      [items]="store.items()"
      [chips]="store.chips()"
      [rootChips]="store.rootChips()"
      [selectedRootChipId]="store.selectedRootNodeId()"
      [chipsDisabled]="store.chipsDisabled()"
      chipsDirection="column"
      (chipClick)="store.selectChip($event)"
      (minimize)="store.minimize()"
      (closed)="store.close()"
    ></app-chat-window>
  }

  @if (store.widgetState() !== 'opened') {
    <app-chat-button-open
      [state]="'default'"
      [type]="store.widgetState() === 'minimized' ? 'minimized' : 'default'"
      (clicked)="store.open()"
    ></app-chat-button-open>
  }
}
